import Layout from "@/views/layout";

const orderRouter = {
  path: "/order",
  name: "Order",
  component: Layout,
  meta: { title: "订单模块" },
  children: [
    {
      path: "purchaseInfo",
      name: "PurchaseInfo",
      component: () => import("@/views/order/purchaseInfo"),
      meta: { title: "参与详情" }
    },
    {
      path: "orderDetail",
      name: "OrderDetail",
      component: () => import("@/views/order/orderDetail"),
      meta: { title: "订单详情" }
    },
    {
      path: "activate",
      name: "Activate",
      component: () => import("@/views/order/activate"),
      meta: { title: "卡券激活" }
    }
  ]
};

export default orderRouter;
